<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <box-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </box-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import BoxForm from './BoxForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { boxService } = biobankRegistry;

export default {
  name: 'BoxCreate',
  components: {
    BoxForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Box',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        console.log('create box data', data);
        const { _id: id } = await boxService.create({ box: data });

        this.$snackbar.showOk({ text: 'Successfully created Box!' });

        this.$router.replace({ name: 'box.edit', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
